export enum ReservationStatusEnum {
    Pending = 1,
    Reserved = 2,
    CheckedIn = 3,
    CheckedOut = 4,
    Cancelled = 5
}